import classNames from 'classnames';
import { ButtonTypes } from '@components/button/Button';
import { Icon, IconName } from '@components/icon';
import './ThumbnailButton.scss';

export interface ThumbnailButtonProps {
  /** type for button html element */
  type?: ButtonTypes;
  /** icon name, sets content and style */
  icon?: IconName;
  /** button text (if no icon) or aria-label (if icon variant) */
  label: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

/**
 * ThumbnailButton component
 * @param type - type for button html element. default 'button'
 * @param icon - icon name, sets content and style
 * @param label - button text (if no icon) or aria-label (if icon variant)
 * @param onClick - onClick action
 */
export const ThumbnailButton: React.FC<ThumbnailButtonProps> = ({
  type = 'button',
  icon,
  label,
  onClick,
  className,
  ...rest
}) => (
  <button
    className={classNames(
      'vds-thumbnail-button',
      'vds-button-text-medium',
      { 'vds-thumbnail-button--icon': icon },
      className,
    )}
    onClick={onClick}
    aria-label={icon ? label : ''}
    type={type}
    {...rest}>
    {icon ? (
      <Icon name={icon} size="small" />
    ) : (
      <span className="vds-thumbnail-button__label">{label}</span>
    )}
  </button>
);
